import {
  type DatePickerProps as MuiDatePickerProps,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import type { Dayjs } from 'dayjs';

type DatePickerPropsWithDate = Omit<
  MuiDatePickerProps<Dayjs>,
  'value' | 'onChange' | 'defaultValue' | 'minDate' | 'maxDate'
> & {
  id?: string;
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  defaultValue?: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
};

const adapter = new AdapterDayjs();
export const DatePicker = ({
  disabled = false,
  format = 'MM/DD/YYYY',
  value,
  onChange,
  defaultValue,
  minDate,
  maxDate,
  ...rest
}: DatePickerPropsWithDate) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        disabled={disabled}
        format={format}
        value={value ? adapter.date(value.toISOString()) : null}
        onChange={(newValue: Dayjs | null) => {
          onChange?.(
            newValue ? adapter.toJsDate(newValue.startOf('day')) : null,
          );
        }}
        defaultValue={
          defaultValue ? adapter.date(defaultValue.toISOString()) : null
        }
        minDate={
          minDate
            ? (adapter.date(minDate.toISOString()) ?? undefined)
            : undefined
        }
        maxDate={
          maxDate
            ? (adapter.date(maxDate.toISOString()) ?? undefined)
            : undefined
        }
        {...rest}
      />
    </LocalizationProvider>
  );
};
